import { Link } from 'react-router-dom';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function RecipesSection() {
  const recipes = [
    {
      id: 1,
      title: 'Mousse de Chocolate Tecnutri',
      image: 'https://readdy.ai/api/search-image?query=elegant%20chocolate%20mousse%20dessert%20in%20glass%20cups%2C%20rich%20creamy%20texture%2C%20chocolate%20shavings%20garnish%2C%20professional%20pastry%20presentation%2C%20restaurant%20quality%20dessert&width=400&height=300&seq=recipe1&orientation=landscape',
      category: 'Sobremesas',
      time: '30 min',
      difficulty: 'Fácil',
      description: 'Mousse cremoso e aerado com sabor intenso de chocolate, perfeito para impressionar seus clientes.'
    },
    {
      id: 2,
      title: 'Refresco Tecnutri',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/c88bb2bd5a68a3a7eea70f43faf28457.jpeg',
      category: 'Bebidas',
      time: '10 min',
      difficulty: 'Muito Fácil',
      description: 'Bebida refrescante com sabores tropicais, ideal para dias quentes e eventos especiais.'
    },
    {
      id: 3,
      title: 'Pudim Tecnutri',
      image: 'https://readdy.ai/api/search-image?query=traditional%20milk%20pudding%20dessert%20with%20caramel%20sauce%2C%20professional%20pastry%20presentation%2C%20creamy%20texture%2C%20golden%20caramel%20topping%2C%20elegant%20dessert%20plating&width=400&height=300&seq=recipe3&orientation=landscape',
      category: 'Sobremesas',
      time: '45 min',
      difficulty: 'Médio',
      description: 'Pudim cremoso com calda de caramelo dourada, uma sobremesa clássica que nunca sai de moda.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-red-600 font-semibold text-lg">Receitas Especiais</span>
          <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-4">
            Criações Deliciosas
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Descubra receitas exclusivas desenvolvidas por nossos chefs para você impressionar seus clientes
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {recipes.map((recipe) => (
            <Card key={recipe.id} hover className="group overflow-hidden">
              <div className="aspect-[4/3] mb-6 overflow-hidden rounded-lg">
                <img
                  src={recipe.image}
                  alt={recipe.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="space-y-4">
                <div>
                  <span className="inline-block px-3 py-1 bg-red-100 text-red-800 text-sm font-medium rounded-full mb-2">
                    {recipe.category}
                  </span>
                  <h3 className="font-semibold text-xl text-gray-900 mb-2 group-hover:text-red-600 transition-colors">
                    {recipe.title}
                  </h3>
                  <p className="text-gray-600 mb-4">
                    {recipe.description}
                  </p>
                </div>
                
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
                  <span className="flex items-center">
                    <i className="ri-time-line mr-1"></i>
                    {recipe.time}
                  </span>
                  <span className="flex items-center">
                    <i className="ri-bar-chart-line mr-1"></i>
                    {recipe.difficulty}
                  </span>
                </div>
                
                <Link to="/receitas">
                  <Button variant="outline" className="w-full">
                    <i className="ri-book-open-line mr-2"></i>
                    Ver Receita
                  </Button>
                </Link>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link to="/receitas">
            <Button size="lg">
              <i className="ri-book-open-line mr-2"></i>
              <font dir="auto" style={{ verticalAlign: 'inherit' }}>Ver Receitas</font>
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
